import { formatDayTime, formatPreadvised, getAssistanceString, isDepartureOrArrivalTask, isPreAdvisedTask, processName } from "_utils/functions";
import { getTaskType } from "./report-utils";



const getPaxName = (task) => {
    let paxName = ""
    if (task.groupedBooking || (task.passengers && task.passengers.length)) {
        paxName = task.passengers.map(pax => processName(pax.name));
        return paxName.join(", ")

    } else {
        return processName(task.passengerInformation?.title, true)

    }
}
function getTaskAssistances(task) {
    const passengerAssistance = task?.passengerInformation?.assistance;
    const assistancesArray = Array.isArray(passengerAssistance) && passengerAssistance.length > 0
        ? passengerAssistance
        : task?.passengers?.map(pax => pax?.assistance);

    return getAssistanceString(assistancesArray?.flat())
}

export const fmtTime = (t, fallback = "N/A") =>
    t ? formatDayTime(t) : fallback;

const findAgentName = (task, employeeList) =>
    employeeList.find((emp) => emp.employeeId === task.employeeId)?.title ??
    task.employeeId ??
    "N/A";

function computeFlightFields(task, iataCode) {
    const typeAD = isDepartureOrArrivalTask(task, iataCode); // "A" or "D"
    const fi = task?.flightInformation ?? {};
    // Scheduled times (your existing fields)
    const scheduledArr = fi.arrivalTime ?? null;
    const scheduledDep = fi.departureTime ?? null;
    // ORG/DES: if Arrival task → show origin (departureAirport)
    //          if Departure task → show destination (arrivalAirport)
    const orgOrDes =
        typeAD === "A" ? fi.departureAirport ?? "N/A" : fi.arrivalAirport ?? "N/A";

    return {
        typeAD: typeAD === "D" ? "DEP" : "ARR", // "A" | "D"
        orgOrDes,
        STA: typeAD === "A" ? fmtTime(scheduledArr) : "—",
        STD: typeAD === "D" ? fmtTime(scheduledDep) : "—",
        // ACT:
        //     typeAD === "A"
        //         ? fmtTime(actualArr) // actual arrival (if present)
        //         : fmtTime(actualDep), // actual departure (if present)
    };
}

//This function generates common fields between all types of tasks (All,Complted,rejected,etc)
export const getCommonTaskProperties = (task, iata, employeeList) => {
    const flight = computeFlightFields(task, iata);
    const preadvised = isPreAdvisedTask(task); // boolean or boolean[]

    // build shared fields once (same for all pax rows)
    const shared = {
        // "Flight Number"
        "FLT NO": task?.flightInformation?.flightNumber?.includes?.("U2")
            ? task.flightInformation.flightNumber.replace("U2", "EZY")
            : task?.flightInformation?.flightNumber ?? "N/A",

        "Arr/Dep": flight.typeAD,
        "Orig/Dest": flight.orgOrDes,

        // "STA", "STD"
        STA: flight.STA,
        STD: flight.STD,

        // "Agent"
        "Agent Name": processName(findAgentName(task, employeeList)),

        // "Task Type"
        "Task Type": getTaskType(task),
        Equipment: task.startedWithEquipment ?? "Not set"
    };

    // normalize passengers → array (or single null to produce 1 row)
    const paxes = Array.isArray(task.passengers) && task.passengers.length
        ? task.passengers
        : [null];

    return paxes.map((pax, idx) => {
        const paxName =
            pax?.name ?? getPaxName(task) ?? "N/A";

        const cat = Array.isArray(pax?.assistance) && pax.assistance.length
            ? pax.assistance.filter(Boolean).join(", ")
            : (Array.isArray(getTaskAssistances(task))
                ? getTaskAssistances(task).join(", ")
                : getTaskAssistances(task) ?? "N/A");

        const preadvVal = Array.isArray(preadvised) ? preadvised[idx] : preadvised;

        return {
            // unique per passenger
            "Passenger Name": processName(paxName),
            Cat: cat,
            "P adv Y/N": formatPreadvised(preadvVal),

            // shared
            ...shared,
        };
    });
};


